import { r as registerInstance, c as createEvent, h, g as getElement, H as Host } from './core-6f498fd9.js';
var Mode;
(function (Mode) {
    Mode[Mode["SINGLE_VALUE"] = 1] = "SINGLE_VALUE";
    Mode[Mode["RANGE_VALUE"] = 2] = "RANGE_VALUE";
})(Mode || (Mode = {}));
var CsmRangeSlider = /** @class */ (function () {
    function CsmRangeSlider(hostRef) {
        registerInstance(this, hostRef);
        this.disabled = false;
        /**
         * The minimum value can no longer equal or exceed the maximum value
         */
        this.nocrossover = false;
        this.updateHighlightNeeded = false;
        this.csmChange = createEvent(this, "csmChange", 7);
        this.csmDrag = createEvent(this, "csmDrag", 7);
    }
    CsmRangeSlider.prototype.valueUpdate = function (value) {
        this.buffer = undefined;
        this.setMode(value);
    };
    CsmRangeSlider.prototype.setMode = function (value) {
        this.mode = isNaN(Number(value)) ? Mode.RANGE_VALUE : Mode.SINGLE_VALUE;
        if (this.mode === Mode.RANGE_VALUE) {
            this.updateHighlightNeeded = true;
        }
    };
    CsmRangeSlider.prototype.onValueChange = function (event) {
        this.value = event.target.value;
        this.csmChange.emit({ value: this.value });
    };
    CsmRangeSlider.prototype.onRangeValueChange = function () {
        this.value = this.getMinMaxSliderValue();
        this.csmChange.emit(Object.assign({}, this.value));
    };
    CsmRangeSlider.prototype.updateSliderHighlight = function () {
        var value = this.getMinMaxSliderValue();
        var _a = this.getInputsElement(), firstInput = _a.firstInput, secondInput = _a.secondInput;
        if (firstInput && secondInput) {
            secondInput.style.setProperty('--low', 100 * ((value.min - this.min) / (this.max - this.min)) + 1 + '%');
            secondInput.style.setProperty('--high', 100 * ((value.max - this.min) / (this.max - this.min)) - 1 + '%');
        }
        this.csmDrag.emit(Object.assign({}, value));
    };
    CsmRangeSlider.prototype.getMinMaxSliderValue = function () {
        var _a = this.getInputsElement(), firstInput = _a.firstInput, secondInput = _a.secondInput;
        if (firstInput && secondInput) {
            if (this.nocrossover) {
                if (this.buffer === undefined) {
                    this.buffer = {
                        min: +firstInput.value || 0,
                        max: +secondInput.value || 0,
                    };
                }
                if (+firstInput.value >= this.buffer.max) {
                    firstInput.value = (+this.buffer.max - +this.step).toString();
                }
                if (+secondInput.value <= this.buffer.min) {
                    secondInput.value = (+this.buffer.min + +this.step).toString();
                }
                return (this.buffer = {
                    min: +firstInput.value,
                    max: +secondInput.value,
                });
            }
            var minValue = Math.min(+firstInput.value, +secondInput.value);
            var maxValue = Math.max(+firstInput.value, +secondInput.value);
            return {
                min: minValue,
                max: maxValue,
            };
        }
    };
    CsmRangeSlider.prototype.getInputsElement = function () {
        var firstInput = this.element.shadowRoot.querySelector('input.csm-range-slider__range-value--first-range');
        var secondInput = this.element.shadowRoot.querySelector('input.csm-range-slider__range-value--second-range');
        return {
            firstInput: firstInput,
            secondInput: secondInput,
        };
    };
    CsmRangeSlider.prototype.componentDidUpdate = function () {
        if (this.updateHighlightNeeded) {
            this.updateSliderHighlight();
            this.updateHighlightNeeded = false;
        }
    };
    CsmRangeSlider.prototype.componentDidRender = function () {
        this.setMode(this.value);
        if (this.mode === Mode.RANGE_VALUE) {
            this.updateSliderHighlight();
        }
    };
    CsmRangeSlider.prototype.render = function () {
        var input = this.mode === Mode.RANGE_VALUE ? ([
            h("input", { type: "range", class: "csm-range-slider__range-value--first-range", onChange: this.onRangeValueChange.bind(this), onInput: this.updateSliderHighlight.bind(this), min: this.min, max: this.max, value: this.value.min, step: this.step }),
            h("input", { type: "range", class: "csm-range-slider__range-value--second-range", onChange: this.onRangeValueChange.bind(this), onInput: this.updateSliderHighlight.bind(this), min: this.min, max: this.max, value: this.value.max, step: this.step }),
        ]) : (h("input", { class: "csm-range-slider__single-value", onChange: this.onValueChange.bind(this), min: this.min, max: this.max, value: this.value, step: this.step, type: "range" }));
        return h(Host, null, input);
    };
    Object.defineProperty(CsmRangeSlider.prototype, "element", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmRangeSlider, "watchers", {
        get: function () {
            return {
                "value": ["valueUpdate"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmRangeSlider, "style", {
        get: function () { return "\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:400;src:url(../assets/fonts/ProximaNova-Regular.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Regular.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:600;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:700;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:900;src:url(../assets/fonts/ProximaNova-Black.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Black.woff) format(\"woff\")}\@font-face{font-family:CS-FontIcon-v19;src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb);src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb#iefix) format(\"embedded-opentype\"),url(../assets/icons/CS-FontIcon-v19.ttf?cz1hbb) format(\"truetype\"),url(../assets/icons/CS-FontIcon-v19.woff?cz1hbb) format(\"woff\"),url(../assets/icons/CS-FontIcon-v19.svg?cz1hbb#CS-FontIcon-v18) format(\"svg\");font-weight:400;font-style:normal;font-display:block}:root{font-family:Proxima Nova,sans-serif}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box;font-family:inherit}:host{display:block;position:relative;height:16px}input[type=range]{-webkit-appearance:none;-moz-appearance:none;appearance:none;width:100%;background:transparent}input[type=range]:focus{outline:none}input[type=range]::-ms-track{width:100%;cursor:pointer;background:transparent;border-color:transparent;color:transparent}input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;height:16px;width:16px;border-radius:50%;background:#4b8ae7;cursor:pointer;margin-top:-4px}input[type=range]::-moz-range-thumb{height:16px;width:16px;border-radius:50%;background:#4b8ae7;cursor:pointer}input[type=range]::-webkit-slider-runnable-track{width:100%;height:6px;cursor:pointer;background:#b7d0f5;border-radius:8px}input[type=range]:focus::-webkit-slider-runnable-track{background:#b7d0f5}input[type=range]::-moz-range-track{width:100%;top:6px;cursor:pointer;background:#b7d0f5;border-radius:8px}input[type=range].csm-range-slider__range-value--first-range::-moz-range-track,input[type=range].csm-range-slider__range-value--second-range::-moz-range-track{border-color:transparent}input[type=range].csm-range-slider__range-value--first-range{position:absolute;top:6px}input[type=range].csm-range-slider__range-value--first-range::-webkit-slider-thumb{position:relative;z-index:2}input[type=range].csm-range-slider__range-value--first-range::-moz-range-thumb{transform:scale(1);z-index:1}input[type=range].csm-range-slider__range-value--second-range{position:absolute;top:6px}input[type=range].csm-range-slider__range-value--second-range::-webkit-slider-runnable-track{background:var(--track-background);--track-background:linear-gradient(90deg,transparent var(--low),var(--range-color) 0,var(--range-color) var(--high),transparent 0) no-repeat;--range-color:#2d538b;height:6px}input[type=range].csm-range-slider__range-value--second-range ::-moz-range-track{background:var(--track-background)}"; },
        enumerable: true,
        configurable: true
    });
    return CsmRangeSlider;
}());
export { CsmRangeSlider as csm_range_slider };
